import React from "react";
import { Row, Col, Label, Input } from "reactstrap";

export default function RenderTab({
  zplCode,
  setZplCode,
  previewUrl,
}) {
  return (
    <Row>
      <Col md={6}>
        <Label>Código ZPL</Label>
        <Input
          type="textarea"
          value={zplCode}
          onChange={(e) => setZplCode(e.target.value)}
          style={{
            fontFamily: 'monospace',
            fontSize: '13px',
            minHeight: '420px',
            resize: 'vertical',
            backgroundColor: '#1e1e1e',
            color: '#d4d4d4',
            border: '1px solid #444',
          }}
        />
      </Col>
      <Col md={6}>
        <Label>Preview</Label>
        <div
          style={{
            minHeight: '420px',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            backgroundColor: '#999999',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'auto',
            padding: '12px',
          }}
        >
          {previewUrl ? (
            <img
              src={previewUrl}
              alt="Preview da etiqueta ZPL"
              style={{ maxWidth: '100%', display: 'block' }}
            />
          ) : (
            <span className="text-muted">Clique em "Renderizar" para ver o preview</span>
          )}
        </div>
      </Col>
    </Row>
  )
}
